<template>
  <a-form-model :model="value" ref="form" class="d-flex flex-column link-list">
    <div class="d-flex flex-row align-items-start mb-2 mr-4" style="gap: 1rem">
      <a-form-model-item :colon="false">
        <template #label><span class="required-label">Link type</span></template>
        <a-select v-model="value.type" size="large" :disabled="loading" allow-clear>
          <template #placeholder><span style="color: #a1a1c2">Select link type</span></template>
          <a-select-option value="custom"> Custom </a-select-option>
          <a-select-option value="sport"> Sport </a-select-option>
          <a-select-option value="match"> Match </a-select-option>
        </a-select>
      </a-form-model-item>

      <div v-if="value.type === 'custom'">
        <a-form-model-item
          :colon="false"
          :rules="[
            {
              required: true,
              message: 'Link is required',
              trigger: ['change', 'blur'],
            },
          ]"
          prop="link"
          ref="link"
          style="min-width: 416px;"
          required
        >
          <template #label>
            <span>Link</span>
            <a-button
              @click="$emit('openModal')"
              :disabled="isLinkModalDisabled"
              size="small"
              type="link"
              style="padding-left: 8px !important; height: 15px; line-height: 18px;"
            >
              Save as a template
            </a-button>
          </template>
          <a-select
            class="media-form__custom-select"
            :disabled="loading"
            v-model="value.link"
            mode="tags"
            optionLabelProp="label"
            size="large"
            @change="handleTemplateChange"
          >
            <template #placeholder>
              <span style="color: #a1a1c2">
                https://www.olimp.bet/line/1/5956496/78487617
              </span>
            </template>
            <a-select-option
              v-for="linkTemplate in filteredLinkTemplates"
              :key="String(linkTemplate.id)"
              :value="String(linkTemplate.url)"
              :label="linkTemplate.url"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <span style="display: block;">{{ linkTemplate.name }}</span>
                  <span style="color: gray; font-size: 12px;">{{ linkTemplate.url?.length > 60 ?
                    linkTemplate.url?.slice(0, 60) + '...' : linkTemplate.url }}</span>
                </div>
                <a-popconfirm
                  overlayClassName="deleteTemplateOverlay"
                  :disabled="false"
                  :getPopupContainer="getPopupContainer"
                  title="Sure to delete this template?"
                  @confirm="(e) => deleteTemplate(e, linkTemplate.id)"
                >
                  <a-icon class="text-danger delete-icon" type="delete" @click.stop />
                </a-popconfirm>
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>

      <a-form-model-item
        v-if="value.type === 'match'"
        :colon="false"
        :rules="[
          {
            required: true,
            message: 'Link is required',
            trigger: ['change', 'blur'],
          },
        ]"
        prop="link"
        ref="matchLink"
        class="mr-3"
        style="min-width: 416px"
      >
        <template #label>Banner link</template>
        <a-input placeholder="https://www.olimp.bet/line/1/5956496/78487617" :disabled="loading"
          v-model="value.link" size="large">
        </a-input>
      </a-form-model-item>

      <a-form-model-item
        v-if="value.type === 'sport'"
        :colon="false"
        :rules="[
          {
            required: true,
            message: 'Selected sport is required',
            trigger: ['change', 'blur'],
          },
        ]"
        prop="sportId"
        ref="sport"
      >
        <template #label>
          Select sport
        </template>
        <a-select v-model="value.sportId" size="large" :disabled="loading" allow-clear>
          <template #placeholder>
            <span style="color: #a1a1c2;">Select sport</span>
          </template>
          <a-select-option v-for="sport in sports" :key="sport.sport_id">
            {{ sport.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </div>
  </a-form-model>
</template>
<script>
import apiClient from '@/services/axios'

export default {
  props: {
    value: Object,
    sports: Array,
    linkTemplates: Array,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getPopupContainer() {
      return document.body
    },
    handleTemplateChange(newTemplate) {
      const filtered = (newTemplate || []).filter(template => template !== '' && template !== undefined)
      const last = filtered[filtered.length - 1] || []
      this.$emit('input', { ...this.value, link: last })
    },
    async deleteTemplate(event, templateId) {
      event.stopPropagation()

      try {
        const url = `/admin/links/${templateId}`
        const linkResponse = await apiClient.delete(url)

        if (!linkResponse || linkResponse.success === false) {
          this.$notification.error({
            message: 'Error while deleting link',
            description: linkResponse?.data.error || 'Unknown error',
          })
          return
        }
        this.$notification.success({
          message: 'Link deleted successfully',
        })
        this.linkTemplates = this.linkTemplates.filter(link => link.id !== templateId)
      } catch (e) {
        this.$notification.error({
          message: 'Error while deleting link',
          description: e.response.data.error.message,
        })
      }
    },
    async validate() {
      let isValid = true

      if (this.value.type === 'sport') {
        await this.$refs.form.validateField('sportId', async (errorMessage) => {
          if (errorMessage) {
            isValid = false
          }
        })
      } else {
        await this.$refs.form.validateField('link', async (errorMessage) => {
          if (errorMessage) {
            isValid = false
          }
        })
      }

      return isValid
    },
    clearValidate() {
      this.$refs.link.clearValidate()
      this.$refs.matchLink.clearValidate()
      this.$refs.sport.clearValidate()
    },
  },
  computed: {
    isLinkModalDisabled() {
      return !this.value?.link?.length
    },
    filteredLinkTemplates() {
      const uniqueTemplates = new Set()
      return this.linkTemplates.filter(template => {
        const url = template.url.trim()
        if (!url || uniqueTemplates.has(url)) {
          return false
        }
        uniqueTemplates.add(url)
        return true
      })
    },
  },
}
</script>
<style lang="scss">
.link-list {
  gap: 1rem;

  .ant-form-item {
    min-width: 200px
  }
}
</style>
